/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccountSecurednessOutput } from './AccountSecurednessOutput';
import {
    AccountSecurednessOutputFromJSON,
    AccountSecurednessOutputFromJSONTyped,
    AccountSecurednessOutputToJSON,
} from './AccountSecurednessOutput';
import type { TargetAllocationOutput } from './TargetAllocationOutput';
import {
    TargetAllocationOutputFromJSON,
    TargetAllocationOutputFromJSONTyped,
    TargetAllocationOutputToJSON,
} from './TargetAllocationOutput';

/**
 * 
 * @export
 * @interface AllocationRunOutput
 */
export interface AllocationRunOutput {
    /**
     * 
     * @type {Array<TargetAllocationOutput>}
     * @memberof AllocationRunOutput
     */
    targetAllocations: Array<TargetAllocationOutput>;
    /**
     * 
     * @type {Array<AccountSecurednessOutput>}
     * @memberof AllocationRunOutput
     */
    securedness: Array<AccountSecurednessOutput>;
}

/**
 * Check if a given object implements the AllocationRunOutput interface.
 */
export function instanceOfAllocationRunOutput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "targetAllocations" in value;
    isInstance = isInstance && "securedness" in value;

    return isInstance;
}

export function AllocationRunOutputFromJSON(json: any): AllocationRunOutput {
    return AllocationRunOutputFromJSONTyped(json, false);
}

export function AllocationRunOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllocationRunOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'targetAllocations': ((json['target_allocations'] as Array<any>).map(TargetAllocationOutputFromJSON)),
        'securedness': ((json['securedness'] as Array<any>).map(AccountSecurednessOutputFromJSON)),
    };
}

export function AllocationRunOutputToJSON(value?: AllocationRunOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'target_allocations': ((value.targetAllocations as Array<any>).map(TargetAllocationOutputToJSON)),
        'securedness': ((value.securedness as Array<any>).map(AccountSecurednessOutputToJSON)),
    };
}

